























































import { Vue, Component } from "@/shared/vuepack";
import { BalanceTransferMethod } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { Home } from "@/shared/route-names";

@Component({
  components: {
    Button
  }
})
export default class TransferFunds extends Vue {
  balanceTransferStore = useBalanceTransferStore();
  featureFlagStore = useFeatureFlagStore();

  BalanceTransferMethod = BalanceTransferMethod;

  get nextDisabled () {
    return this.balanceTransferStore.transferMethod === BalanceTransferMethod.None;
  }

  get useEnhancedFlow () {
    return this.featureFlagStore.flags.bend33430EnhancedBalanceTransfer;
  }

  updateSelection (transferMethod: BalanceTransferMethod) {
    this.balanceTransferStore.transferMethod = transferMethod;
  }

  isSelected (transferMethod: BalanceTransferMethod) {
    return this.balanceTransferStore.transferMethod === transferMethod;
  }

  onSkip () {
    this.$router.push({ name: Home });
  }

  onNext () {
    switch (this.balanceTransferStore.transferMethod) {
      case BalanceTransferMethod.TrusteeToTrustee:
        this.goToNextTrusteeStep();
        break;
      case BalanceTransferMethod.Rollover:
        this.balanceTransferStore.goToStep("rollover-details");
        break;
    }
  }

  goToNextTrusteeStep () {
    if (this.useEnhancedFlow) {
      this.balanceTransferStore.goToStep("trustee-provider");
    } else {
      this.balanceTransferStore.goToStep("trustee-details");
    }
  }
}
